import {
  FAIL_SUGGESTIONS,
  REQUEST_SUGGESTIONS,
  SUCCESS_SUGGESTIONS,
} from 'shared/searchBarActions';

function combineExcluded(state = {}, feedUsers) {
  const excludedIds = state.excludedIds ? state.excludedIds : [];
  const newIds = [];
  feedUsers.forEach(feedUser => {
    newIds.push(feedUser.feedUserId);
  });

  return [...newIds, ...excludedIds];
}

export default function suggestionsReducer(state = {}, action) {
  switch (action.type) {
  case REQUEST_SUGGESTIONS:
    return {
      ...state,
      ... {
        isFetching: true,
      },
    };
  case FAIL_SUGGESTIONS:
    return {
      ...state,
      ... {
        isFetching: false,
      },
    };
  case SUCCESS_SUGGESTIONS:
    const {
      suggested,
    } = action.payload;

    return {
      ...state,
      ...{
        excludedIds: combineExcluded(state, suggested),
        isFetching: false,
        suggested,
      },
    };
  default:
    return state;
  }
}
